<div class="max-w-6xl mx-auto px-4 py-8">
  <div class="flex flex-wrap -mx-4">
    <!-- Image Section Skeleton -->
    <div class="w-full md:w-2/5 px-4 mb-8">
      <div class="rounded-lg shadow-lg overflow-hidden bg-gray-50" style="aspect-ratio: 4/3; max-height: 480px;">
        <nz-skeleton-element
          style="width: 100% !important; height: 100% !important"
          class="h-full w-full"
          nzType="image"
          [nzActive]="true"
        ></nz-skeleton-element>
      </div>
    </div>

    <!-- Event Details Section Skeleton -->
    <div class="w-full md:flex-1 px-4">
      <nz-skeleton [nzActive]="true" [nzParagraph]="{ rows: 8 }"></nz-skeleton>
    </div>
  </div>
</div>
